import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";
import { Button, Label, TextArea } from "abs-ui-components";
import "./FeuB9EnergyEmissions.scss";
import { commonFormFields } from "../../FeuConstants.js";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes.js";
import { callApi } from "../../../../../services/MonitoringPlanService.js";
import { emitToasterMsg } from "../../../../../services/toasterUtility.js";
import AutoSave from "../../../../../common/AutoSave/AutoSave.js";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants.js";

const FeuB9EmissionfactorsAnnex2 = forwardRef(({ b9FuelEmissionFactorsData, refetchMonitoringData,vesselMstId }, ref) => {

    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);


    useEffect(() => {
        if (b9FuelEmissionFactorsData) {
            reset(prev => ({ ...prev, b9: b9FuelEmissionFactorsData }));
        }
    }, [b9FuelEmissionFactorsData, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });


    const handleSave = async (isAuto = false) => {
        const formValues = getValues("b9");
        const payload = {
            ...commonFormFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };

        try {
            const b9EmissionFactors = await callApi({
                method: "POST",
                url: API_ROUTES.B9(vesselMstId),
                data: payload,
            });
            if (b9EmissionFactors?.isSuccess) {
                emitToasterMsg("success", "Table B.9", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, b34: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table B.9", b9EmissionFactors?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table B.9", error.errorMessage);
        }
    };

    return (
        <div className="b9-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Monitoring and reporting the well-to tank and tank-to-wake emission factors of energy to be used on-board</h6>
                </MDBCol>
            </MDBRow>
            {commonFormFields.map(({ label, name, maxLength }, index) => (
                <MDBRow className="align-items-center mb-3" key={index}>
                    <MDBCol md="4">
                        <Label name={label} bold />
                    </MDBCol>
                    <MDBCol md="4">
                        <Controller
                            name={`b9.${name}`}
                            control={control}
                            render={({ field }) => (
                                <TextArea
                                    id={`b9_${name}`}
                                    className="textarea-resize"
                                    value={field?.value || ""}
                                    onChange={field.onChange}
                                    placeholder=""
                                    maxLength={maxLength}
                                    rows={1}
                                />
                            )}
                        />
                    </MDBCol>
                </MDBRow>
            ))}

            <div className="text-center">
                <Button id="b9_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                >Save</Button>
            </div>
        </div>
    );
});



export default FeuB9EmissionfactorsAnnex2;